<div [@expansion]="expanded ? 'open' : 'closed'">
  <ng-content />
  <ng-template [cdkPortalOutlet]="portal" />
</div>
